import(/* webpackMode: "eager", webpackExports: ["SignUpForm"] */ "/vercel/path0/app/auth/sign-up-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
